import React, {useContext, useEffect, useState} from 'react';
import __ from "lodash";
import {Grid} from "@material-ui/core";
import SystemContext from "../../../SystemContext";
import {formatChars} from "../../../blocks/FormatCharacters";
import {FormDialog, MaskedText} from "../../../controls";
import Validator from "../validators/NewCompanyValidator";
import {useAddCompany} from "../../../services/companies";


const NewCompanyCaptureDialog = (props) => {

  const classes = props.classes;
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {
      companyName: "",
      companyCode: null,
      branchCode: null,
      iataAgentCode: null,
      cassAddress: null,
      accountNumber: null,
      participantCode: null,
      isContractClient: true,
    },
    handleSave: null
  });

  useEffect(() => {
    const open = () => {
      setDialogStates({...dialogStates, showDialog: true});
    }
    const close = () => {
      setDialogStates({...dialogStates, showDialog: false});
    }

    if (eventBus) {
      eventBus.bind('NewCompanyCapture.open', open);
      eventBus.bind('NewCompanyCapture.close', close);
    }
    return () => {
      eventBus.unbind('NewCompanyCapture.open', open);
      eventBus.unbind('NewCompanyCapture.close', close);
    }
  }, [eventBus]);

  const handleAddCompany = useAddCompany();

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left" }}>

      <FormDialog
        title={props.title}
        message="Enter new company basic details"
        open={dialogStates.showDialog}
        record={dialogStates?.record || {}}
        dialogOptions={{maxWidth: "sm", fullWidth: false}}
        movable={true}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            SystemData.toggleLoadingProgress(true);

            handleAddCompany.mutate({
              extraKeys: [],
              record: state.record,
              postSuccess: (result) => {
                SystemData.toggleLoadingProgress(false);
                let companyUuid = null;
                let companyName = null;
                if (result && __.has(result, "status") && result.status === "SUCCESS" && __.has(result, "record") && __.has(result.record, "data")) {
                  companyUuid = result.record.data?.companyUuid;
                  companyName = result.record.data?.companyName;
                }
                setDialogStates({showDialog: false, record: null});
                props.onChange({companyUuid, companyName});
              },
              postError: (data) => {
                SystemData.toggleLoadingProgress(false);
                if (data.errorMessage) {
                  if (__.has(data.errorMessage, "response") &&
                      __.has(data.errorMessage.response, "data") &&
                      __.has(data.errorMessage.response.data, "errorMessage") &&
                      data.errorMessage.response.data.errorMessage !== "") {
                    const actualError = data.errorMessage.response.data.errorMessage;
                    SystemData.alert("Error", actualError);
                  } else {
                    SystemData.alert("Error", `An Unexpected Error has occurred saving the new Company. ${data.errorMessage}`);
                  }
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred saving the new Company`);
                }
              }
            });
          } else {
            setDialogStates({showDialog: false, record: null});
            props.onChange({companyUuid: null, companyName: null});
          }
        }}
      >
        <div style={{marginBottom: 20}}></div>

        <Grid container checkChildren={true} spacing={2}>
          <Grid item xs={12} checkChildren={true}>
            {record => (
              <MaskedText
                id="companyName"
                label="New Company Name"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            {record => (
              <MaskedText
                id="companyCode"
                label="Company Code"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            {record => (
              <MaskedText
                id="branchCode"
                label="Branch Code"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            {record => (
              <MaskedText
                id="iataAgentCode"
                label="IATA Agent Code"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            {record => (
              <MaskedText
                id="cassAddress"
                label="CASS Address"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            {record => (
              <MaskedText
                id="accountNumber"
                label="Account Number"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>
          <Grid item xs={6} checkChildren={true}>
            {record => (
              <MaskedText
                id="participantCode"
                label="Participant Code"
                inputLabelProps={{shrink: true}}
                fullWidth
                mask={"x".repeat(50)}
                maskChar={""}
                forceSentenceCase={true}
                alwaysShowMask={false}
                formatChars={formatChars}
              />
            )}
          </Grid>

        </Grid>

      </FormDialog>
    </div>
  )
}

export default NewCompanyCaptureDialog;
